import React                       from 'react';
import PropTypes                   from 'prop-types';
import Background                  from './Jumbotron/Background';
import Category                    from './Jumbotron/Category';
import Logo                        from './Jumbotron/Logo';
import VisibilitySensor            from 'react-visibility-sensor';
import Flux                        from '../../flux/Flux';
import {getSeoHeadlineTranslation} from "../../utils/TranslationHelper";

class Jumbotron extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			windowWidth: Flux.Browser.getWindowSize().width,
		};

		this.background         = null;
		this.onClick            = this.onClickHandler.bind(this);
		this.onVisibilityChange = this.onVisibilityChange.bind(this);
		this.onResize           = this.onResizeHandler.bind(this);
	}

	componentDidMount() {
		if (this.props.responsive) {
			Flux.Browser.addWindowResizeListener(this.onResize);
		}
	}

	componentWillUnmount() {
		if (this.props.responsive) {
			Flux.Browser.removeWindowResizeListener(this.onResize);
		}
	}

	onClickHandler() {
		if (this.background) {
			this.background.onClickVideo();
		}
	}

	onVisibilityChange(visible) {
		if (this.background) {
			if (visible) {
				this.background.startVideo();
			} else {
				this.background.stopVideo();
			}
		}
	}

	onResizeHandler() {
		this.setState({
			windowWidth: Flux.Browser.getWindowSize().width,
		});
	}

	render() {
		let cols = this.props.isMobile ? 2 : (this.props.responsive ? 5 : 4);

		if (!this.props.isMobile && this.props.responsive) {
			if (this.state.windowWidth > Flux.Constants.TileGridBreakpoints.FiveCols) {
				cols = 5;
			} else if (this.state.windowWidth > Flux.Constants.TileGridBreakpoints.FourCols) {
				cols = 4;
			} else if (this.state.windowWidth > Flux.Constants.TileGridBreakpoints.ThreeCols && Flux.Browser.isPortrait()) {
				cols = 4;
			} else if (this.state.windowWidth > Flux.Constants.TileGridBreakpoints.ThreeCols) {
				cols = 3;
			} else {
				cols = 2;
			}
		}

		const toShow     = cols === 2 ? 4 : cols;
		const colsClass  = 'has-cols-' + cols;
		const categories = this.props.categories
			.map((c, k) => (k < toShow) ? <Category {...c} key={k} lazyImageLoading={this.props.lazyImageLoading} /> : null);

		const background = !this.props.isMobile
			? <Background ref={ref => this.background = ref}
			              image={this.props.image}
			              video={this.props.video}
			              showVideo={this.props.showVideo}
			              actors={this.props.actors}
			/>
			: null;

		return (
			<VisibilitySensor onChange={this.onVisibilityChange} partialVisibility={true}>
				<section className={"video-jumbotron " + colsClass} onClick={this.onClick}>
					{background}
					<div className={"video-jumbotron__foreground" + (this.props.isMobile && this.props.isCategoryPage ? ' -category-page' : '')}>
						{this.props.showForegroundText && <div className="video-jumbotron__foreground-text">
							{!this.props.isMobile ? <Logo /> : null}
							<h1 className="video-jumbotron__foreground-title">{this.props.title}</h1>
						</div>}
						<div className="video-jumbotron__foreground-categories">{categories}</div>
					</div>
				</section>
			</VisibilitySensor>
		);
	}
}

Jumbotron.propTypes = {
	title:              PropTypes.string,
	isMobile:           PropTypes.bool,
	showVideo:          PropTypes.bool,
	responsive:         PropTypes.bool,
	image:              PropTypes.string,
	video:              PropTypes.string,
	categories:         PropTypes.arrayOf(PropTypes.shape({
		title:    PropTypes.string,
		subTitle: PropTypes.string,
		image:    PropTypes.string,
		url:      PropTypes.string,
	})),
	actors:             PropTypes.arrayOf(PropTypes.shape({
		id:                PropTypes.number,
		name:              PropTypes.string,
		profileLink:       PropTypes.string,
		previewPictureUrl: PropTypes.string,
		isOnline:          PropTypes.bool,
	})),
	isCategoryPage:     PropTypes.bool,
	lazyImageLoading:   PropTypes.bool,
	showForegroundText: PropTypes.bool,
};

Jumbotron.defaultProps = {
	title:              getSeoHeadlineTranslation(Flux.Browser.isSexole() ? 'videostation_jumbotron_title_h1--sexole' : 'videostation_jumbotron_title_h1'),
	isMobile:           false,
	showVideo:          false,
	responsive:         false,
	categories:         [],
	actors:             [],
	isCategoryPage:     false,
	lazyImageLoading:   false,
	showForegroundText: true,
};

export default Jumbotron;
